import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { DeliveryNoteEndpoint } from '../../constants/delivery-note-endpoint';
import { DeliveryNoteParams, DeliveryNotePartiesModel } from '../../models';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNotePartiesService {
  constructor(private http: WrapperHttpService) {}

  getParties({ deliveryNoteNumber, sapId }: DeliveryNoteParams): Observable<DeliveryNotePartiesModel[]> {
    const params = sapId ? `?${getQueryStringFromObject({ sapId })}` : '';

    return this.http
      .withLoading()
      .get<DeliveryNotePartiesModel[]>(
        `${API_URL}${DeliveryNoteEndpoint.Base}${DeliveryNoteEndpoint.Monitoring}${DeliveryNoteEndpoint.DeliveryNote}/${deliveryNoteNumber}${DeliveryNoteEndpoint.Parties}${params}`,
      );
  }
}
